module.exports = __webpack_public_path__ + "img/row3col2.96822a90.png";